import http from "./http";

export const GetQuestions = async (query = '') => {
  return await http.get(`/questions${query}`);
}

export const SelectAnwser = async (id) => {
  return await http.get("/user/answers/" + id);
}